import BaseService from "./base";
export class UserService extends BaseService {
    constructor() {
        super("user");
    }

    getLoggedInUser() {
        return this.api("me")
    }
}
